import lottie from 'lottie-web';
import React, { useEffect, useRef } from 'react';

function LottieAnimation({ animationData, loop = true, isPaused = false }) {
	const containerRef = useRef(null);
	const animationInstance = useRef(null);

	useEffect(() => {
		animationInstance.current = lottie.loadAnimation({
			container: containerRef.current,
			renderer: 'svg',
			loop,
			autoplay: true,
			animationData,
		});

		return () => {
			if (animationInstance.current) {
				animationInstance.current.destroy();
				animationInstance.current = null;
			}
		};
	}, [animationData, loop]);

	useEffect(() => {
		if (animationInstance.current) {
			if (isPaused) {
				animationInstance.current.pause();
			} else {
				animationInstance.current.play();
			}
		}
	}, [isPaused]);

	return (
		<div
			ref={containerRef}
			style={{
				height: 'auto',
				width: 'inherit',
				display: 'flex',
				alignItems: 'center',
			}}
		/>
	);
}
export default LottieAnimation;
